document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuOverlay = document.querySelector('[data-menu-overlay]');
  const cartToggles = document.querySelectorAll('[data-cart-toggle]');
  const cartDrawer = document.getElementById('cart-drawer');

  if (menuToggle && menuOverlay) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuOverlay.classList.toggle('is-open');
      menuToggle.classList.toggle('is-active');
      
      cartToggles.forEach(toggle => toggle.classList.toggle('is-active', isOpen));

      if (isOpen) {
        document.body.style.overflow = 'hidden';
        document.body.classList.add('menu-open');
      } else {
        document.body.style.overflow = '';
        document.body.classList.remove('menu-open');
      }
    });

    menuOverlay.addEventListener('click', (event) => {
      if (event.target === menuOverlay) {
        menuOverlay.classList.remove('is-open');
        menuToggle.classList.remove('is-active');
        cartToggles.forEach(toggle => toggle.classList.remove('is-active'));
        document.body.style.overflow = '';
        document.body.classList.remove('menu-open');
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menuOverlay.classList.contains('is-open')) {
        menuOverlay.classList.remove('is-open');
        menuToggle.classList.remove('is-active');
        cartToggles.forEach(toggle => toggle.classList.remove('is-active'));
        document.body.style.overflow = '';
        document.body.classList.remove('menu-open');
      }
    });
  }

  // Cart i18n strings from DOM
  const cartStrings = {
    remove: document.getElementById('cart-i18n-remove')?.dataset.value || 'Remove',
    empty: document.getElementById('cart-i18n-empty')?.dataset.value || 'Your cart is empty',
    goToShop: document.getElementById('cart-i18n-go-to-shop')?.dataset.value || 'Go to Shop',
    adding: document.getElementById('cart-i18n-adding')?.dataset.value || 'Adding...'
  };

  // Cart Drawer Logic
  const cartCloseButtons = document.querySelectorAll('[data-cart-close]');

  const openCartDrawer = () => {
    if (!cartDrawer) return;
    
    if (menuOverlay && menuOverlay.classList.contains('is-open')) {
      menuOverlay.classList.remove('is-open');
      menuToggle.classList.remove('is-active');
      document.body.classList.remove('menu-open');
    }
    
    cartDrawer.classList.add('active');
    cartDrawer.classList.add('opening');
    setTimeout(() => cartDrawer.classList.remove('opening'), 450);
    
    document.body.style.overflow = 'hidden';
  };

  const closeCartDrawer = () => {
    if (!cartDrawer) return;
    
    cartDrawer.classList.add('closing');
    
    setTimeout(() => {
      cartDrawer.classList.remove('active');
      cartDrawer.classList.remove('closing');
      
      const isMenuOpen = menuOverlay && menuOverlay.classList.contains('is-open');
      if (!isMenuOpen) {
        document.body.style.overflow = '';
      }
    }, 450);
  };

  const formatMoney = (cents, format) => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '${{amount}}';

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  const updateCartUI = async () => {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const cartCounts = document.querySelectorAll('[data-cart-count]');
      cartCounts.forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      
      const subtotals = document.querySelectorAll('[data-cart-subtotal]');
      const moneyFormat = window.theme?.moneyFormat || '${{amount}}';
      
      subtotals.forEach(el => {
        el.textContent = formatMoney(cart.total_price, moneyFormat);
      });

      const itemsContainer = document.querySelector('[data-cart-items]');
      const drawerFooter = document.querySelector('.cart-drawer__footer');

      if (itemsContainer) {
        const drawerFooter = document.querySelector('.cart-drawer__footer');
        if (cart.item_count > 0) {
          if (drawerFooter) drawerFooter.style.display = '';
          let itemsHtml = '';
          // Fetch product images for all items
const productHandles = [...new Set(cart.items.map(i => i.handle))];
const productImages = {};
await Promise.all(productHandles.map(async handle => {
  try {
    const r = await fetch(`/products/${handle}.js`);
    const p = await r.json();
    productImages[handle] = p.images || [];
  } catch(e) {}
}));

cart.items.forEach((item, index) => {
  const line = index + 1;
  const variantSuffix = item.variant_title && item.variant_title !== 'Default Title' 
    ? ` - ${item.variant_title}` 
    : '';
  
  const images = productImages[item.handle] || [];
  const drawerImage = images[2] || images[1] || item.image;
  const drawerImageSrc = drawerImage?.src || drawerImage;

  itemsHtml += `
    <div class="cart-drawer__item" data-cart-item-id="${item.id}" data-line="${line}">
      <div class="cart-drawer__item-image">
        ${drawerImageSrc ? `<img src="${drawerImageSrc}" alt="${item.title}" loading="lazy">` : ''}
      </div>
                <div class="cart-drawer__item-info">
                  <div class="cart-drawer__item-top">
                    <h3 class="cart-drawer__item-title">${item.product_title.toUpperCase()}${variantSuffix}</h3>
                    <div class="cart-drawer__item-price">${formatMoney(item.final_line_price, moneyFormat)}</div>
                  </div>
                  <div class="cart-drawer__item-bottom">
                    <div class="cart-drawer__quantity">
                      <button type="button" class="cart-drawer__qty-btn" data-quantity-change="minus" data-line="${line}">−</button>
                      <span class="cart-drawer__qty-value">${item.quantity}</span>
                      <button type="button" class="cart-drawer__qty-btn" data-quantity-change="plus" data-line="${line}">+</button>
                    </div>
                    <button type="button" class="cart-drawer__item-remove" data-remove-item data-line="${line}">${cartStrings.remove}</button>
                  </div>
                </div>
              </div>
            `;
          });
          itemsContainer.innerHTML = itemsHtml;
        } else {
          if (drawerFooter) drawerFooter.style.display = 'none';
          itemsContainer.innerHTML = `
            <div class="cart-drawer__empty">
              <p>${cartStrings.empty}</p>
              <a href="/collections/tienda" class="cart-drawer__shop-btn">${cartStrings.goToShop.toUpperCase()}</a>
            </div>
          `;
        }
      }
    } catch (e) {
      console.error('Error updating cart UI', e);
    }
  };

  if (cartDrawer) {
  cartDrawer.classList.add('mounted');
}

// Ocultar footer si carrito vacío al cargar
const drawerFooterInit = document.querySelector('.cart-drawer__footer');
if (drawerFooterInit && document.querySelector('[data-cart-items] .cart-drawer__empty')) {
  drawerFooterInit.style.display = 'none';
}

  if (cartToggles.length > 0 && cartDrawer) {
    cartToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        openCartDrawer();
      });
    });

    cartCloseButtons.forEach(button => {
      button.addEventListener('click', closeCartDrawer);
    });
  }

  // Cart drawer: remove item + quantity change (event delegation)
  if (cartDrawer) {
    cartDrawer.addEventListener('click', async (e) => {
      const removeBtn = e.target.closest('[data-remove-item]');
      const qtyBtn = e.target.closest('[data-quantity-change]');
      
      if (removeBtn) {
        e.preventDefault();
        const line = parseInt(removeBtn.getAttribute('data-line'));
        if (!line) return;
        
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: 0 })
          });
          await updateCartUI();
        } catch (err) {
          console.error('Error removing item', err);
        }
      }
      
      if (qtyBtn) {
        e.preventDefault();
        const line = parseInt(qtyBtn.getAttribute('data-line'));
        const direction = qtyBtn.getAttribute('data-quantity-change');
        if (!line) return;
        
        const item = qtyBtn.closest('.cart-drawer__item');
        const qtyValue = item?.querySelector('.cart-drawer__qty-value');
        if (!qtyValue) return;
        
        const currentQty = parseInt(qtyValue.textContent) || 1;
        const newQty = direction === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);
        
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: newQty })
          });
          await updateCartUI();
        } catch (err) {
          console.error('Error updating quantity', err);
        }
      }
    });
  }

  // Custom Select Dropdown
  const customSelects = document.querySelectorAll('[data-custom-select]');
  customSelects.forEach(select => {
    const trigger = select.querySelector('[data-select-trigger]');
    const optionsContainer = select.querySelector('[data-select-options]');
    const options = select.querySelectorAll('[data-select-option]');
    const label = select.querySelector('[data-select-label]');
    const nativeSelect = select.querySelector('[data-native-select]');

    if (trigger && optionsContainer) {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = select.classList.toggle('is-open');
        
        customSelects.forEach(other => {
          if (other !== select) other.classList.remove('is-open');
        });
      });

      options.forEach(option => {
        option.addEventListener('click', () => {
          const value = option.getAttribute('data-value');
          const text = option.textContent.trim();

          if (label) label.textContent = text;
          if (nativeSelect) {
            nativeSelect.value = value;
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }

          options.forEach(opt => opt.classList.remove('is-selected'));
          option.classList.add('is-selected');

          select.classList.remove('is-open');
        });
      });
    }
  });

  document.addEventListener('click', () => {
    customSelects.forEach(select => select.classList.remove('is-open'));
  });

  const productForm = document.getElementById('product-form');

  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const submitBtn = productForm.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = cartStrings.adding.toUpperCase();

      try {
        const formData = new FormData(productForm);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
  await updateCartUI();
  openCartDrawer();
} else {
  let errorMsg = 'Error adding to cart';
  try {
    const error = await response.json();
    errorMsg = error.description || errorMsg;
  } catch(e) {}
  console.error('Cart error:', errorMsg);
  // Mostrar error inline en lugar de alert
  const submitBtn = productForm.querySelector('[type="submit"]');
  submitBtn.textContent = errorMsg;
  submitBtn.style.background = '#111';
  setTimeout(() => {
    submitBtn.textContent = originalText;
    submitBtn.style.background = '';
  }, 3000);
}
      } catch (error) {
        console.error('Error adding to cart', error);
        alert('Error adding to cart');
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    });

    const selects = productForm.querySelectorAll('select');
    selects.forEach((select) => {
      select.addEventListener('change', () => {
        console.log('Variant option changed. Needs JSON mapping to update hidden ID input.');
      });
    });
  }

  // Search Toggle & Live Filtering
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchInput = document.querySelector('[data-search-input]');
  const productCards = document.querySelectorAll('.product-card-item');
  const noResultsMsg = document.querySelector('.no-results-msg');

  if (searchToggle && searchInput) {
    searchToggle.addEventListener('click', () => {
      searchInput.classList.toggle('is-active');
      if (searchInput.classList.contains('is-active')) {
        searchInput.focus();
      }
    });

    searchInput.addEventListener('input', (e) => {
      const searchTerm = e.target.value.toLowerCase().trim();
      let hasResults = false;

      productCards.forEach(card => {
        const cardProduct = card.querySelector('.card-product');
        if (cardProduct) {
          const title = cardProduct.getAttribute('data-product-title');
          if (title.includes(searchTerm)) {
            card.style.display = '';
            hasResults = true;
          } else {
            card.style.display = 'none';
          }
        }
      });

      if (noResultsMsg) {
        noResultsMsg.style.display = hasResults ? 'none' : 'block';
      }
    });
  }

  // Quantity Selector
  const quantitySelectors = document.querySelectorAll('.quantity-selector');
  quantitySelectors.forEach(selector => {
    const input = selector.querySelector('[data-quantity-input]');
    const minusBtn = selector.querySelector('[data-quantity-btn="minus"]');
    const plusBtn = selector.querySelector('[data-quantity-btn="plus"]');

    if (input && minusBtn && plusBtn) {
      minusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue > 1) {
          input.value = currentValue - 1;
        }
      });

      plusBtn.addEventListener('click', () => {
        const currentValue = parseInt(input.value) || 1;
        input.value = currentValue + 1;
      });
    }
  });

  // Accordions
  const accordions = document.querySelectorAll('[data-accordion]');
  accordions.forEach(accordion => {
    const trigger = accordion.querySelector('[data-accordion-trigger]');
    if (trigger) {
      trigger.addEventListener('click', () => {
        const isOpen = accordion.classList.contains('is-open');
        
        accordions.forEach(item => item.classList.remove('is-open'));
        
        if (!isOpen) {
          accordion.classList.add('is-open');
        }
      });
    }
  });

  // Product Lightbox Logic
  const lightbox = document.getElementById('product-lightbox');
  const lightboxTriggers = document.querySelectorAll('[data-lightbox-trigger]');
  const lightboxImage = document.querySelector('[data-lightbox-image]');
  const lightboxCounter = document.querySelector('[data-lightbox-counter]');
  const lightboxCloseButtons = document.querySelectorAll('[data-lightbox-close]');
  const lightboxPrev = document.querySelector('[data-lightbox-prev]');
  const lightboxNext = document.querySelector('[data-lightbox-next]');
  const productImagesData = document.querySelector('[data-product-images]');
  
  let currentImageIndex = 0;
  let productImages = [];

  if (productImagesData) {
    try {
      productImages = JSON.parse(productImagesData.textContent);
    } catch (e) {
      console.error('Error parsing product images JSON', e);
    }
  }

  const updateLightbox = (index) => {
    if (!productImages[index]) return;
    
    currentImageIndex = index;
    lightboxImage.style.opacity = '0';
    lightboxImage.classList.remove('is-zoomed');
    lightboxImage.style.transformOrigin = 'center center';
    
    setTimeout(() => {
      lightboxImage.src = productImages[index];
      lightboxImage.onload = () => {
        lightboxImage.style.opacity = '1';
      };
      if (lightboxCounter) {
        lightboxCounter.textContent = `${currentImageIndex + 1} / ${productImages.length}`;
      }
    }, 150);
  };

  const openLightbox = (index) => {
    if (!lightbox) return;
    updateLightbox(index);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    lightboxImage.classList.remove('is-zoomed');
    lightboxImage.style.transformOrigin = 'center center';
    
    const isMenuOpen = menuOverlay && menuOverlay.classList.contains('is-open');
    const isCartOpen = cartDrawer && cartDrawer.classList.contains('active');
    if (!isMenuOpen && !isCartOpen) {
      document.body.style.overflow = '';
    }
  };

  const navigateLightbox = (direction) => {
    let newIndex = currentImageIndex + direction;
    if (newIndex < 0) newIndex = productImages.length - 1;
    if (newIndex >= productImages.length) newIndex = 0;
    updateLightbox(newIndex);
  };

  if (lightboxTriggers.length > 0) {
    lightboxTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const index = parseInt(trigger.getAttribute('data-index')) || 0;
        openLightbox(index);
      });
    });

    lightboxCloseButtons.forEach(btn => {
      btn.addEventListener('click', closeLightbox);
    });

    if (lightboxImage) {
      lightboxImage.addEventListener('click', (e) => {
        e.stopPropagation();
        
        if (!lightboxImage.classList.contains('is-zoomed')) {
          const rect = lightboxImage.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          
          lightboxImage.style.transformOrigin = `${x}% ${y}%`;
          lightboxImage.classList.add('is-zoomed');
        } else {
          lightboxImage.classList.remove('is-zoomed');
          lightboxImage.style.transformOrigin = 'center center';
        }
      });

      lightboxImage.addEventListener('mousemove', (e) => {
        if (!lightboxImage.classList.contains('is-zoomed')) return;
        
        const rect = lightboxImage.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        
        lightboxImage.style.transformOrigin = `${x}% ${y}%`;
      });
    }

    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', (e) => {
        e.stopPropagation();
        navigateLightbox(-1);
      });
    }

    if (lightboxNext) {
      lightboxNext.addEventListener('click', (e) => {
        e.stopPropagation();
        navigateLightbox(1);
      });
    }

    document.addEventListener('keydown', (e) => {
      if (!lightbox || !lightbox.classList.contains('is-open')) return;
      
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') navigateLightbox(-1);
      if (e.key === 'ArrowRight') navigateLightbox(1);
    });
  }

  // Jaray Lookbook Viewer
  function initLookbook() {
    const section = document.querySelector('.page-drop');
    if (!section) return;

    const lookbook = document.getElementById('jaray-lookbook');
    if (!lookbook) return;

    const imagesContainer = lookbook.querySelector('[data-lookbook-images]');
    const titleEl = lookbook.querySelector('[data-lookbook-title]');
    const descEl = lookbook.querySelector('[data-lookbook-description]');
    
    const triggers = section.querySelectorAll('[data-lookbook-trigger]');
    const closeBtns = lookbook.querySelectorAll('[data-lookbook-close]');
    const prevBtn = lookbook.querySelector('[data-lookbook-prev]');
    const nextBtn = lookbook.querySelector('[data-lookbook-next]');

    let currentIndex = 0;
    const dataEl = document.getElementById('jaray-looks-data');
    if (!dataEl) return;
    
    const looks = JSON.parse(dataEl.textContent);

    function openLookbook(index) {
      currentIndex = index;
      updateLookbook();
      lookbook.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLookbook() {
      lookbook.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function updateLookbook() {
      const look = looks[currentIndex];
      if (!look) return;

      titleEl.textContent = look.title;
      descEl.innerHTML = look.description;
      
      imagesContainer.innerHTML = '';
      look.images.forEach(src => {
        if (src) {
          const img = document.createElement('img');
          img.src = src;
          img.loading = 'lazy';
          imagesContainer.appendChild(img);
        }
      });
      
      imagesContainer.scrollTop = 0;
      const layout = lookbook.querySelector('.jaray-lookbook__layout');
      if (layout) layout.scrollTop = 0;
    }

    function nextLook() {
      currentIndex = (currentIndex + 1) % looks.length;
      updateLookbook();
    }

    function prevLook() {
      currentIndex = (currentIndex - 1 + looks.length) % looks.length;
      updateLookbook();
    }

    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const index = parseInt(trigger.dataset.index);
        openLookbook(index);
      });
    });

    closeBtns.forEach(btn => btn.addEventListener('click', closeLookbook));
    if (nextBtn) nextBtn.addEventListener('click', nextLook);
    if (prevBtn) prevBtn.addEventListener('click', prevLook);

    document.addEventListener('keydown', (e) => {
      if (lookbook.getAttribute('aria-hidden') === 'false') {
        if (e.key === 'Escape') closeLookbook();
        if (e.key === 'ArrowRight') nextLook();
        if (e.key === 'ArrowLeft') prevLook();
      }
    });
  }

  initLookbook();
  document.addEventListener('shopify:section:load', initLookbook);
});

// Hide header on scroll down, show on scroll up
(function() {
  const header = document.querySelector('.collection-header');
  if (!header) return;
  
  let lastScrollY = window.scrollY;
  let ticking = false;
  
  const updateHeader = () => {
    const currentScrollY = window.scrollY;
    
    if (currentScrollY < 50) {
      header.classList.remove('is-hidden');
    } else if (currentScrollY > lastScrollY) {
      header.classList.add('is-hidden');
    } else if (currentScrollY < lastScrollY) {
      header.classList.remove('is-hidden');
    }
    
    lastScrollY = currentScrollY;
    ticking = false;
  };
  
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });
})();

// Cart page interactions
(function() {
  const cartPage = document.querySelector('.cart-page');
  if (!cartPage) return;
  
  const refreshCart = () => {
    window.location.reload();
  };
  
  const updateLine = async (line, quantity) => {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      if (response.ok) {
        refreshCart();
      }
    } catch (err) {
      console.error('Error updating cart', err);
    }
  };
  
  cartPage.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-cart-qty]');
    const removeBtn = e.target.closest('[data-cart-remove]');
    
    if (qtyBtn) {
      e.preventDefault();
      const line = parseInt(qtyBtn.getAttribute('data-line'));
      const direction = qtyBtn.getAttribute('data-cart-qty');
      const input = cartPage.querySelector(`.cart-page__qty-input[data-line="${line}"]`);
      if (!input) return;
      
      const currentQty = parseInt(input.value) || 1;
      const newQty = direction === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);
      
      updateLine(line, newQty);
    }
    
    if (removeBtn) {
      e.preventDefault();
      const line = parseInt(removeBtn.getAttribute('data-line'));
      updateLine(line, 0);
    }
  });
})();